module.exports = __webpack_public_path__ + "img/Banner2.7716c543.png";